import { createRoute } from "@tanstack/react-router";
import { requirePermissions } from "@/app/guards";
import { CERTIFICATES_PERMISSIONS } from "@/app/nav";
import { CertificateDetailPage } from "@/features/certificates/CertificateDetailPage";
import { CertificateSearch } from "@/features/certificates/CertificateSearch";
import { type PageSearch, pageSearch } from "@/routes/paging";
import { staffRoute } from "@/routes/staff";

type CertificatesSearch = { q?: string; batch?: string } & PageSearch;

const nonEmpty = (value: unknown) => (typeof value === "string" && value.trim() !== "" ? value.trim() : undefined);

export const certificatesRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "certificates",
  // Set, never omit, each key: the router merges this over the raw query string.
  validateSearch: (search: Record<string, unknown>): CertificatesSearch => ({
    q: nonEmpty(search.q),
    batch: nonEmpty(search.batch),
    ...pageSearch(search),
  }),
  beforeLoad: ({ context }) => requirePermissions(context.session, CERTIFICATES_PERMISSIONS),
  component: CertificateSearch,
});

export const certificateDetailRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "certificates/$certificateId",
  beforeLoad: ({ context }) => requirePermissions(context.session, CERTIFICATES_PERMISSIONS),
  component: CertificateDetailPage,
});
